export default __webpack_public_path__ + "static/media/buttons-card-2.024f55a5.svg";